var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideosVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.6552V11.6754C10 10.5815 10 10.0345 10.2229 9.75933C10.4166 9.5201 10.7097 9.38343 11.0175 9.3888C11.3715 9.39498 11.7905 9.74655 12.6285 10.4497L13.8082 11.4396L13.8082 11.4396C14.3102 11.8609 14.5612 12.0715 14.6529 12.3233C14.7333 12.5442 14.7333 12.7864 14.6529 13.0073C14.5612 13.2591 14.3102 13.4697 13.8082 13.891L12.6285 14.8809C11.7905 15.584 11.3715 15.9356 11.0175 15.9418C10.7097 15.9472 10.4166 15.8105 10.2229 15.5713C10 15.2961 10 14.7491 10 13.6552Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.66528,
    width: 16,
    height: 16,
    rx: 3,
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideosVector);
export default __webpack_public_path__ + "static/media/VideosVector.11f7d977bf0fe475d2a8766463e7520f.svg";
export { ForwardRef as ReactComponent };